export type ProcessStep = { n: string; title: string; body: string };

export function ProcessSteps({ steps }: { steps: ProcessStep[] }) {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {steps.map((s) => (
        <div key={s.n} className="rounded-card border border-border bg-navy-card p-6">
          <span className="font-display text-3xl font-semibold text-cyan/40">{s.n}</span>
          <h3 className="mt-4 font-display text-base font-semibold text-text-primary">
            {s.title}
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-text-secondary">{s.body}</p>
        </div>
      ))}
    </div>
  );
}
